import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-article-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class ArticleForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;

  public permissionEntityNameToUse = 'articles';
  public formModel: AnyEntity = {};
  public showImpactAlert: boolean = false;
  isArticleImpactsEnabled: boolean = this.$store.getters['centerSettings/useArticleImpacts'];

  // created() {}
  mounted() {
    this.$root.$on('changeArticleType', val => {
      this.$refs.stdForm.formModel.articleBookingDetail = null;
    });

    this.$root.$on('show-article-impact-alert', val => {
      if (this.isArticleImpactsEnabled) {
        this.showImpactAlert = true;
      }
    });
  }

  destroyed() {
    this.$root.$off('changeArticleType');
    // this.$root.$off('show-article-impact-alert');
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(event) {
    this.$emit('delete-media-file', event);
  }
  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
}
